/* global API_ROOT */
import { createAction } from '@reduxjs/toolkit'
import { fetchHelper } from '../utils/fetch'

// SPEC-099 FR-9: the newsletter toggle in account settings. The state lives
// in the component (it's read fresh on every visit), so these actions have
// no reducer; the dispatchers read the result tuple.
export const types = {
  NEWSLETTER_FETCH_SUCCESS: 'NEWSLETTER_FETCH_SUCCESS',
  NEWSLETTER_FETCH_FAILURE: 'NEWSLETTER_FETCH_FAILURE',
  NEWSLETTER_UPDATE_SUCCESS: 'NEWSLETTER_UPDATE_SUCCESS',
  NEWSLETTER_UPDATE_FAILURE: 'NEWSLETTER_UPDATE_FAILURE'
}

export const newsletterFetchSuccess = createAction(
  types.NEWSLETTER_FETCH_SUCCESS
)
export const newsletterFetchFailure = createAction(
  types.NEWSLETTER_FETCH_FAILURE
)
// GET → { subscribed }
export const newsletterFetch = fetchHelper(
  `${API_ROOT}/newsletter/`,
  { method: 'GET', hidden: true },
  newsletterFetchSuccess,
  newsletterFetchFailure
)

export const newsletterUpdateSuccess = createAction(
  types.NEWSLETTER_UPDATE_SUCCESS
)
export const newsletterUpdateFailure = createAction(
  types.NEWSLETTER_UPDATE_FAILURE
)
// PUT { subscribed } → { subscribed, status: subscribed | pending | unsubscribed }
// The server records consent under its own text version; nothing else is sent.
export const newsletterUpdate = fetchHelper(
  `${API_ROOT}/newsletter/`,
  { method: 'PUT', hidden: true },
  newsletterUpdateSuccess,
  newsletterUpdateFailure
)
